import * as yup from 'yup';
import { YupSchema } from './interfaces';

export const getSchema = () => {
  const staticValidations: YupSchema = {
    firstName: yup.string().required(),
    lastName: yup.string().required(),
    phone: yup.string().required(),
    birthDate: yup.string().required(),
    about: yup.string().required(),
    education: yup.string().required(),
    sex: yup.string().required(),
    mattermost: yup.string().required(),
    tg: yup
      .string()
      .required()
      .matches(/^[a-zA-Z][\w_]{4,31}$/, 'Not valid TG nick'),
  };

  return yup.object().shape(staticValidations);
};
